// The root of the web app: providers every page needs, the error page, and
// the route tree from routes/registry.tsx (every screen of docs/v3/COVERAGE.md).
import { Outlet, ScrollRestoration, useRouteError, type RouteObject } from "react-router";
import { useMeta } from "./api/meta";
import { buildRoutes } from "./routes/registry";
import { isChunkLoadError } from "./routes/types";
import { PublicShell } from "./shell/Shells";
import { Notice } from "./ui/Notice";
import { PageHeader } from "./ui/PageHeader";
import { ToastProvider } from "./ui/Toast";

function Root() {
  useMeta(); // load the product name and help address once, early
  return (
    <ToastProvider>
      <Outlet />
      <ScrollRestoration />
    </ToastProvider>
  );
}

/** Shown when a page crashes: never a blank screen. */
function RouteError() {
  const error = useRouteError();
  const meta = useMeta();
  if (import.meta.env.DEV) console.error(error);
  return (
    <PublicShell>
      <div className="signin-card" data-error-page="true">
        <PageHeader title="Something went wrong" />
        <Notice kind="error" title="This page could not be shown">
          <p>
            {/* LF-N1: a file of an older version that is gone after an update. */}
            {isChunkLoadError(error) ? "Convenor was updated while this page was open. " : null}
            Reload the page. If it happens again, write to <a href={`mailto:${meta.supportEmail}`}>{meta.supportEmail}</a>.
          </p>
        </Notice>
        <p>
          <a href="/">Go to your start page</a>
        </p>
      </div>
    </PublicShell>
  );
}

export const appRoutes: RouteObject[] = [{ element: <Root />, errorElement: <RouteError />, children: buildRoutes() }];
